import React, { useState, useEffect } from "react";
import asdas123a from "../image/asdas123a.png";

const SocialKakao3 = () => {
  const Rest_api_key = "128ac2386cfdbf1d2caa4979003fbdf7"; //REST API KEY
  const redirect_uri = "https://nametec.kr/"; //Redirect URI
  // oauth 요청 URL
  const kakaoURL = `https://kauth.kakao.com/oauth/authorize?client_id=${Rest_api_key}&redirect_uri=${redirect_uri}&response_type=code`;
  const handleLogin = () => {
    window.location.href = kakaoURL;
  };
  return (
    <>
      <img
        loading="lazy"
        src={asdas123a}
        onClick={handleLogin}
        style={{ width: "380px", marginTop: "12px", marginLeft: "301px" }}
      />
    </>
  );
};
export default SocialKakao3;
